const StringUtils = {
  pluralize,
};

function pluralize(string, count) {
  return count === 1 ? string : `${string}s`;
}

export default StringUtils;
